import type { VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const NewSectionTemplatePage_SectionTemplate_Create_Mutation = graphql(`
  mutation NewSectionTemplatePage_SectionTemplate_Create(
    $sectionTemplate: SectionTemplateInput!
    $versionData: VersionDataInput
  ) {
    createSectionTemplate(doc: $sectionTemplate, versionData: $versionData) {
      _id
    }
  }
`);

export type SectionTemplateInput = VariablesOf<
  typeof NewSectionTemplatePage_SectionTemplate_Create_Mutation
>['sectionTemplate'];

export const useCreateSectionTemplateMutation = () =>
  useGraphQLMutation(NewSectionTemplatePage_SectionTemplate_Create_Mutation);
